import { render, staticRenderFns } from "./PaymentMethodName.vue?vue&type=template&id=39cd4b1a&scoped=true"
import script from "./PaymentMethodName.vue?vue&type=script&lang=js"
export * from "./PaymentMethodName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cd4b1a",
  null
  
)

export default component.exports